import { sanitizeId } from '../../../../utils'

const sanitizeStoreAddress = ({ address, city, zip }) => {
  const stringable = [address]
  if (city) stringable.push(city)
  if (!city && zip) stringable.push(zip)
  return stringable.join(' ')
}

export function sanitizeStoreData(store) {
  return {
    ...store,
    address: sanitizeStoreAddress(store),
    id: sanitizeId(store.id),
    lat: parseFloat(store.lat),
    lng: parseFloat(store.lng),
  }
}

export function sanitizeStoresData(stores) {
  return stores.map(sanitizeStoreData)
}
